<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'

const translaterStore = useTranslaterStore()

const getTranslate = computed(() => translaterStore.getTranslate)
</script>

<template>
    <div class="d-flex flex-column justify-content-center align-items-center h-100">

        <h1 class="page--404-title">
            404
        </h1>

        <h2 class="page--404-subtitle">
            {{ getTranslate.NOTFOUND_SUBTITLE }}
        </h2>

        <router-link class="page--404-link" to="/">
            {{ getTranslate.NOTFOUND_LINK }}
        </router-link>

    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/404.scss';
</style>